import { axiosClient } from "../../../config";
import { OFFICE_CODE, SEARCH_RESERVATION_URL } from "../../../utilities/constants";
import { setCurrentRez, setSearchResult, updateAttributeByName } from "./searchRezSlice";
import i18n from '../../../config/lang';
import { toast } from 'react-toastify';
import { startShowLoader, stopShowLoader } from "../../../store/loader";

const t = i18n.t;

export const startSearchReservationByCode = ({ reservationCode, lastName, FromQr = false }) => {
    return async( dispatch ) => {
        dispatch( startShowLoader() );
        dispatch( setCurrentRez(null) );
        const { status: statusResponse, data: response} = await axiosClient.post(SEARCH_RESERVATION_URL, {
            ReservationCode: reservationCode,
            LastName: lastName,
            pickupLocationCode: OFFICE_CODE,
            FromQr
        })
        .catch(e => e);

        dispatch( stopShowLoader() );
        if (statusResponse != 200 || response?.type != "success") {
            dispatch( setSearchResult([]) );
            toast.error(response.message);
            return false;
        }
        dispatch( setSearchResult(response.data) );
        return true;
    }
}

export const startSearchReservatiionByBasicData = ({ firstName, lastName, email }) => {
    return async( dispatch ) => {
        dispatch( startShowLoader() );
        dispatch( setCurrentRez(null) );
        const { status: statusResponse, data: response} = await axiosClient.post(SEARCH_RESERVATION_URL, {
            firstName,
            lastName,
            email,
            pickupLocationCode: OFFICE_CODE
        })
        .catch(e => e);

        dispatch( stopShowLoader() );
        if (statusResponse != 200 || response?.type != "success") {
            dispatch( setSearchResult([]) );
            toast.error(t('Error.unexpected_error_occurred', 'An unexpected error occurred, please try again later.'));
            return false;
        }
        dispatch( setSearchResult(response.data) );
        return true;
    }
}

export const setSearchLoading = (value) => {
    return async( dispatch ) => {
        dispatch( setLoading(value) );
    }
}

export const setSearchRezChangesValues = (name, value) => {
    return async( dispatch ) => {
        dispatch( updateAttributeByName({ name, value }) );
    }
}

export const setSelectedRez = ( reservationItem ) => {
    return async( dispatch ) => {
        dispatch( setCurrentRez(reservationItem) );
    }
}
